import { useOktaAuth } from '@okta/okta-react';
import { IS_AI_ASSISTANT_ENABLED } from '@src/constants';
import { getCurrentDeploymentEnvironment, isEmailAllowedForFeature } from '@src/common-utils/utils';

import { isAiServiceConfigured } from '../api/service-config';
import { AI_ASSISTANT_ALLOWED_EMAILS_BY_ENV } from '../constants';

// The three independent gates that decide whether the assistant is shown to the
// current user: the code switch, whether the AI service is deployed in this
// environment, and the per-user allowlist (skipped in prod, where it's open to all)
export function useIsAiAssistantEnabled(): boolean {
  const { authState } = useOktaAuth();
  const email = authState?.idToken?.claims?.email;
  return (
    IS_AI_ASSISTANT_ENABLED &&
    isAiServiceConfigured() &&
    (getCurrentDeploymentEnvironment() === 'prod' ||
      isEmailAllowedForFeature(AI_ASSISTANT_ALLOWED_EMAILS_BY_ENV, email))
  );
}
